import {Injectable} from '@angular/core';


import {TbsaResultsService} from '../../TbsaResults/tbsa-results.service';

import {ClientInfoService} from '../../ClientInfo/client-info.service';
import {DataExchangeService} from '../../../../../surface3d/src/lib/API/Public/data-exchange.service';
import {EditorControlService} from '../../../../../surface3d/src/lib/API/Public/editor-control.service';


@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    private _modelSelection = false;
    private _iosScrolling: boolean;
    // 0 = model for model view / 1 = model for draw view
    private _curModelMode: number;

    constructor(private dataExchangeService: DataExchangeService,
                private tbsaResultsService: TbsaResultsService,
                private clientInfoService: ClientInfoService,
                private editorControlService: EditorControlService) {
        this._curModelMode = 1;
    }

    get data(): any {
        return this.tbsaResultsService.data;
    }

    get finish(): boolean {
        return this.tbsaResultsService.finish;
    }

    get total(): string {
        return this.tbsaResultsService.total;
    }

    get parkland(): string {
        return this.tbsaResultsService.parkland;
    }

    /**
     * Gets the current mode in which the model is.
     */
    public getCurModelMode(): number {
        return this._curModelMode;
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    /**
     * sets model selection mode inactive
     */
    public deactivateModelSelection() {
        this.tbsaResultsService.finish = false;
        this._modelSelection = true;
    }

    /**
     * Collects the TBSA results and hides/shows brush options
     */
    public collectBurnData() {
        this.tbsaResultsService.finish = false;
        this.tbsaResultsService.collectBurnData();
    }

    /**
     * disables scrolling on iphones/ipads
     */
    public disableIosScrolling() {
        document.body.scrollTo(0, 0);
        this._iosScrolling = !this._iosScrolling;

        // TODO: test with other browsers/devices
        const ios = /iPhone|iPad/i.test(window.navigator.userAgent);
        if (ios && !this.clientInfoService.isStandalone) {
            if (!this._iosScrolling) {
                document.addEventListener('touchmove', this.preventScrolling, {passive: false});
            } else {
                document.removeEventListener('touchmove', this.preventScrolling);
            }
        }
    }

    /**
     * disables scrolling on diverse devices
     */
    public disableScrolling() {
        document.addEventListener('touchend', () => document.body.scrollTo(0, 0), {passive: false});
        document.addEventListener('touchstart', () => document.body.scrollTo(0, 0), {passive: false});

        if (this.clientInfoService.isStandalone) {
            document.addEventListener('touchmove', this.preventScrolling, {passive: false});
        }
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

    private preventScrolling(event: Event) {
        event.preventDefault();
    }

    /**
     * Updates the view size of the canvas where the model is shown.
     */
    public updateViewSize() {
        this.dataExchangeService.updateViewSize();
    }

    /**
     * Reset the model in t-pose.
     */
    public resetModel() {
        // reset model to standard t-pose
        this.editorControlService.ctrl.next('reset');
    }

    /**
     * Loads the model in the draw-view.
     */
    public loadDrawViewResetControls() {
        // set model in mode for draw view
        this._curModelMode = 1;
        this.dataExchangeService.switchView('editor');
        this.editorControlService.resetOrbitControls();
        this.dataExchangeService.patient.loadMorphedModel();
        this.dataExchangeService.updateViewSize();
    }

    /**
     * Loads the model in the model-view.
     */
    public loadModelViewResetControls() {
        // set model in mode for model view
        this._curModelMode = 0;
        this.resetModel();
        this.dataExchangeService.switchView('shape');
        // loads model for model-view
        this.dataExchangeService.patient.initializeShapeView();
        console.log('shape');
    }
}
